import {
  getGuaranteesUakdoControlInitialValues,
} from '../step7/utils.ts';
import type { TGuaranteesExecutionForm } from '~/store/guarantees/types.ts';
import {
  GuaranteesUakdoControllerControlFieldName,
  type TGuaranteesUakdoControllerControlFormValues,
} from './types.ts';

export const getGuaranteesUakdoControllerControlInitialValues = (
  executionForm?: TGuaranteesExecutionForm | null
): TGuaranteesUakdoControllerControlFormValues => {
  const uakdoControlValues = getGuaranteesUakdoControlInitialValues(executionForm);

  return {
    [GuaranteesUakdoControllerControlFieldName.ExecutorMainDealConditionsStatus]:
      uakdoControlValues.executorMainDealConditionsStatus,
    [GuaranteesUakdoControllerControlFieldName.UnfulfilledConditionsDetails]:
      uakdoControlValues.unfulfilledConditionsDetails,
    [GuaranteesUakdoControllerControlFieldName.CoverageAccountPlacementStatus]:
      uakdoControlValues.coverageAccountPlacementStatus,
    [GuaranteesUakdoControllerControlFieldName.DepositAccountPlacementStatus]:
      uakdoControlValues.depositAccountPlacementStatus,
  };
};
